
import * as React from "react";

function SvgSplitData(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.83398 15.1654V1.83203H2.83398V15.1654H1.83398ZM7.66732 11.832V5.16536H9.33398V11.832H7.66732ZM14.1673 15.1654V1.83203H15.1673V15.1654H14.1673Z" fill="#2466EA"/>
    </svg>
  );
}

export default SvgSplitData;
